
const particlesConfig = {
	"particles": {
		"number": {
			"value": 159,
			"density": {
				"enable": true,
				"value_area": 10000
			}
		},
		"color": {
			"value": "#8cc541"
		},
		"shape": {
			"type": "polygon",
			"stroke": {
				"width": 1,
				"color": "#8cc541"
			},
			"polygon": {
				"nb_sides": 6
			}
			// "image": {
			// 	"src": "/resources/themes/fastrack-theme/images/svg/archive-symbol.svg",
			// 	"width": 100,
			// 	"height": 100
			// }
		},
		"opacity": {
			"value": 0,
			"random": false,
			"anim": {
				"enable": false,
				"speed": 1,
				"opacity_min": 0.1,
				"sync": false
			}
		},
		"size": {
			"value": 20,
			"random": true,
			"anim": {
				"enable": false,
				"speed": 40,
				"size_min": 4.060386061506725,
				"sync": false
			}
		},
		"line_linked": {
			"enable": false,
			"distance": 150,
			"color": "#ffffff",
			"opacity": 0.4,
			"width": 1
		},
		"move": {
			"enable": true,
			"speed": 4,
			"direction": "none",
			"random": false,
			"straight": false,
			"out_mode": "out",
			"bounce": false,
			"attract": {
				"enable": true,
				"rotateX": 600,
				"rotateY": 1200
			}
		}
	},
	"interactivity": {
		"detect_on": "canvas",
		"events": {
			"onhover": {
				"enable": true,
				"mode": "repulse"
			},
			"onclick": {
				"enable": false,
				"mode": "bubble"
			},
			"resize": true
		},
		"modes": {
			"grab": {
				"distance": 400,
				"line_linked": {
					"opacity": 1
				}
			},
			"bubble": {
				"distance": 400,
				"size": 40,
				"duration": 2,
				"opacity": 8,
				"speed": 3
			},
			"repulse": {
				"distance": 138.05312609122865,
				"duration": 0.4
			},
			"push": {
				"particles_nb": 4
			},
			"remove": {
				"particles_nb": 2
			}
		}
	},
	"retina_detect": true
};


const Particles = {

	elementId: 'particles-js',

	init: function () {
		particlesJS('particles-js', particlesConfig, function () {
			console.log('LOADED');
		});
	}

};

export default Particles;
